// import { 
//     // ApolloClient,
//     InMemoryCache,
//     // createHttpLink,
//     // ApolloLink,
//     // HttpLink,
//     // split,
  
// } from '@apollo/client/react';

import { HttpLink,ApolloLink,ApolloClient,InMemoryCache } from "@apollo/client";

import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

import { createUploadLink } from "apollo-upload-client";

// import {setContext} from "@apollo/client/link/context";
// import {store} from '../Store/store';

// const state = store.getState();
console.log("WS URL:", process.env.REACT_APP_SOCKET_API);
console.log("HTTP URL:", process.env.REACT_APP_HOST_API);

const wslink = new GraphQLWsLink(
  createClient({ url: `${process.env.REACT_APP_SOCKET_API}` })
);

// const httpLink = new HttpLink({uri: process.env.REACT_APP_HOST_API});
const uploadLink = createUploadLink({uri: process.env.REACT_APP_HOST_API})

const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('accessToken');
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      'Apollo-Require-Preflight': 'true',
    },
  });

  return forward(operation);
})

const splitLink = ApolloLink.split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    const isSubscription =
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription';
    return isSubscription;
  },
  wslink,
  authLink.concat(uploadLink),
);

export const apolloClient  = new ApolloClient ({
  link: splitLink,
  cache: new InMemoryCache(),
});